'use client';

import { c as _c } from "react/compiler-runtime";
import { Alert, Box, Stack, Typography } from '@mui/material';
import { SUPPORT_EMAIL } from '@/components/support/support';
import { Tag } from '@/components/tag';
import { useUser } from '@/contexts/useUser';
const roleLabelByName: Record<string, string> = {
  'Eon support': 'Support Admin',
  'Eon support viewer': 'Support Viewer'
};
export const SupportUserBanner = () => {
  const $ = _c(7);
  const {
    user
  } = useUser();
  if (!user?.email?.endsWith(SUPPORT_EMAIL)) {
    return null;
  }
  const role = user.selectedRole;
  const roleLabel = roleLabelByName[role.name] ?? role.name;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i className="material-symbols-verified-user-outline-rounded" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      borderRadius: "0px",
      padding: "6px 16px",
      "& .MuiAlert-message": {
        width: "100%"
      },
      "& .MuiAlert-icon": {
        alignItems: "center"
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "8px",
      alignItems: "center",
      width: "100%"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography variant="subtitle2Strong" sx={{
      color: "inherit"
    }}>You are signed in as Eon Support</Typography>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      marginLeft: "auto"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== roleLabel) {
    t5 = <Alert severity="warning" variant="filled" icon={t0} sx={t1}><Stack direction="row" sx={t2}>{t3}<Box sx={t4}><Tag content={roleLabel} /></Box></Stack></Alert>;
    $[5] = roleLabel;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};